<template>
  <div class="fts-display" :class="{'comfort-design': comfortDesign}">
    <template v-if="model">
      <!-- yes no -->
      <div
        class="fts-display-form-control yes-no-display"
        v-if="item.type === 1"
      >
        <font-awesome-icon
          class="success-theme"
          :icon="['fas', 'check']"
          fixed-width
          v-if="model === 'Yes'"
        />
      </div>
      <!-- module -->
      <div
        class="fts-display-form-control dropdown-display"
        v-else-if="item.type === 7"
      >
        <a
          class="display-entry-link"
          :href="getEntryURL()"
          target="_blank"
          @click.prevent="openQuickView()"
          v-if="isConnectionLink && getEntryId()"
        >
          {{ model }}
        </a>
        <!-- default -->
        <template v-else>{{ model }}</template>
      </div>
      <!-- modules -->
      <div
        class="fts-display-form-control display-dropdown"
        v-else-if="item.type === 8"
      >
        <div class="display-dropdown-tag-container">
          <div
            v-for="x in model"
            :key="x.id"
            class="display-dropdown-tag"
          >
            <a
              :href="getEntryURL(x)"
              target="_blank"
              class="display-entry-link"
              @click.prevent="openQuickView(x)"
              v-if="isConnectionLink && x.id"
            >
              {{x.name}}
            </a>
            <template v-else>
              {{x.name}}
            </template>
          </div>
        </div>
      </div>
      <!-- location -->
      <div
        class="fts-display-form-control location-display"
        v-else-if="item.type === 9"
      >
        <fts-tippy
          content="View location on Google Maps"
          v-if="model && model.lat && model.lng"
        >
          <a
            :href="`http://www.google.com/maps/place/${model.lat},${model.lng}`"
            target="_blank"
          >
            <font-awesome-icon :icon="['fas', 'map-marked-alt']" />
          </a>
        </fts-tippy>
        <div class="location-name">{{ model.placeName }}</div>
      </div>
      <!-- table -->
      <fts-table-edit-display
        ref="tableEditDisplay"
        @freeze-summary="summary => $emit('freeze-summary', summary)"
        :form-data="model"
        :item="item"
        :vector-id="vectorId"
        :activity-id="activityId"
        :overflow-auto="overflowAuto" 
        :view="view" 
        :share-form="shareForm" 
        :comfort-design="comfortDesign" 
        :sticky-header="formSettings && formSettings.tableStickyHeader" 
        :hide-label-icon="formSettings && formSettings.hideLabelIcon" 
        :form-key="formSettings && formSettings.tableFreezeFormKey"
        v-else-if="item.type === 14"
      />
      <!-- list -->
      <fts-list
        :vector-id="vectorId"
        :form-data="formData"
        :item="item"
        :view="view"
        v-else-if="item.type === 15"
      />
      <!-- multiline text -->
      <div
        class="fts-display-form-control multi-text-display"
        ref="ftsDisplayTextArea"
        v-else-if="item.type === 16"
      >
        <span>{{ model }}</span>
      </div>
      <!-- image(s), file(s) -->
      <fts-file
        class="file-upload-display"
        :prefixURL="`${vectorId}-${item.id}`"
        :data="model"
        :file-type="fileType"
        downloadable
        v-else-if="fileType"
      />
      <!-- username -->
      <fts-profile
        :user-name="model"
        :profile-photo-size="comfortDesign ? 24 : 21"
        profile-group
        class="fts-display-form-control"
        v-else-if="item.type === 19"
      />
      <!-- user -->
      <fts-profile
        :user-name="userNameModel"
        :profile-photo-size="comfortDesign ? 24 : 21"
        profile-name-class="dropdown-user-display-name"
        class="fts-display-form-control dropdown-user-display"
        v-else-if="item.type === 20"
      >
        <template #profileName="{ userProfile }">
          <div v-if="shareForm">{{model}}</div>

          <a
            class="display-entry-link"
            :href="getEntryURL()"
            target="_blank"
            @click.prevent="openQuickView()"
            v-else-if="isConnectionLink && getEntryId()"
          >
            {{ model }}
          </a>

          <fts-display-profile-card 
            append-to-body 
            :profile="userProfile" 
            :profile-name="model" 
            append-trigger-class="stopPropagation" 
            v-else 
          />
        </template>
      </fts-profile>
      <!-- users -->
      <div
        class="fts-display-form-control display-user display-user--multiple"
        v-else-if="item.type === 21"
      >
        <div
          v-for="x in model"
          :key="x.id"
          class="display-user-tag"
        >
          <fts-profile :user-name="x.username" :profile-photo-size="comfortDesign ? 24 : 21">
            <template #profileName="{ userProfile }">
              <div v-if="shareForm">{{x.name}}</div>

              <a
                :href="getEntryURL(x)"
                target="_blank"
                class="display-entry-link"
                @click.prevent="openQuickView(x)"
                v-else-if="isConnectionLink && x.id"
              >
                {{x.name}}
              </a>

              <fts-display-profile-card 
                append-to-body 
                :profile="userProfile" 
                :profile-name="x.name" 
                append-trigger-class="stopPropagation" 
                v-else 
              />
            </template>
          </fts-profile>
        </div>
      </div>
      <!-- content -->
      <div
        class="display-content"
        v-else-if="item.type === 22"
        v-html="model"
      ></div>
      <!-- context -->
      <div
        class="fts-display-form-control context-display"
        v-else-if="item.type === 24"
      >
        <div
          class="context-display-item"
          v-for="option in model"
          :key="option.id"
        >
          {{ option.name }}
        </div>
      </div>
      <!-- email -->
      <div
        class="fts-display-form-control contact-link-display"
        v-else-if="item.type === 25"
      >
        {{ model }}
        <fts-tippy
          content="Send mail"
          class="contact-link-display-shortcut"
        >
          <a :href="'mailto:' + model">
            <font-awesome-icon :icon="['far', 'envelope']" />
          </a>
        </fts-tippy>
      </div>
      <!-- phone number -->
      <div
        class="fts-display-form-control contact-link-display"
        v-else-if="item.type === 26"
      >
        {{ model }}
        <fts-tippy
          content="Open in WhatsApp"
          class="contact-link-display-shortcut"
        >
          <a target="_blank" :href="waLink">          
            <font-awesome-icon :icon="['fab', 'whatsapp']" />
          </a>
        </fts-tippy>
      </div>
      <!-- select -->
      <div
        class="fts-display-form-control display-dropdown"
        v-else-if="item.type === 27 && !item.reference"
      >
        <div
          class="fts-display-form-tag display-dropdown-tag"
          :style="{ 'background-color': getColor(model) }"
        >
          {{ model }}
        </div>
      </div>
      <!-- tag -->
      <div
        class="fts-display-form-control display-dropdown"
        v-else-if="item.type === 28"
      >
        <div class="display-dropdown-tag-container">
          <div
            v-for="x in model"
            :key="x.id"
            class="fts-display-form-tag display-dropdown-tag"
            :style="{ 'background-color': getColor(x) }"
          >
            {{x}}
          </div>
        </div>
      </div>
      <!-- signature -->
      <template v-else-if="shareForm && inTable && item.type === 29">
        <template v-if="view || item.display || item.readOnly">
          <div class="fts-display-form-control fts-cursor-pointer" @click="openSignatureModal">
            <fts-badge color="primary">
              signed
            </fts-badge>
          </div>

          <fts-client-modal
            width="400px"
            :title="item.label || item.displayName"
            class="display-signature-modal"
            ref="signature-modal"
          >
            <div slot="body" class="display-signature-modal-container">
              <fts-file
                :prefixURL="`${vectorId}-${item.id}`"
                :data="model"
                file-type="image"
                :image-width="300"
                :image-height="150"
                image-contain
                preview-disabled
              />
            </div>
          </fts-client-modal>
        </template>

        <div class="fts-display-form-control" v-else>
          <fts-badge color="primary">
            signed
          </fts-badge>
        </div>
      </template>

      <fts-file
        class="signature-display"
        :prefixURL="`${vectorId}-${item.id}`"
        :data="model"
        file-type="image"
        file-content-class="signature-display-content"
        :image-width="300"
        :image-height="150"
        image-contain
        downloadable
        :preview-disabled="filePreviewDisabled"
        v-else-if="item.type === 29"
      />
      <!-- link -->
      <div class="fts-display-form-control" v-else-if="item.type === 33">
        <!-- link:query -->
        <div
          class="fts-link-primary"
          @click="toggleQueryUrl"
          v-if="isQueryUrl"
        >
          {{ model.name }}
        </div>
        <!-- link:UNC -->
        <a
          class="fts-link-primary"
          target="_blank"
          :href="uNCFilePath"
          v-else-if="uNCFilePath"
        >
          {{ model.name }}
        </a>
        <!-- link:default -->
        <a
          class="fts-link-primary"
          target="_blank"
          :href="linkURL"
          v-else-if="linkURL"
        >
          {{ model.name }}
        </a>
        <!-- link:name -->
        <template v-else>{{ model.name }}</template>
      </div>
      <!-- default -->
      <div class="fts-display-form-control normal-display" v-else>
        {{ model }}
      </div>
    </template>

    <div
      class="fts-display-form-control fts-cursor-pointer"
      v-else-if="
        shareForm && 
        inTable &&
        !view && 
        !item.display &&
        !item.readOnly && 
        item.type === 29
      "
    >
      <fts-badge color="text">
        <font-awesome-icon :icon="['fas', 'hand-point-right']" /> sign here
      </fts-badge>
    </div>

    <!-- footer -->
    <slot name="footer" :model="model" />
  </div>
</template>

<script>
import Vue from 'vue';
import numeral from 'numeral';

import { clientStore } from '../store/clientStore';
import commons from '../commons/commons';
import { openDocumentLink } from './documentLink';
import { uNCValidator } from '../commons/validator';

import FTSBadge from './FTSBadge';
import FTSClientModal from './FTSClientModal';
import FTSDisplayProfileCard from './FTSDisplayProfileCard';
import FTSFile from './file/FTSFile';
import FTSList from './FTSList';
import FTSProfile from './FTSProfile';
import FTSTableEditDisplay from './FTSTableEditDisplay';
import FTSTippy from './FTSTippy';

export default {
  props: {
    vectorId: [Number, String],
    /* form identity for the per-form freeze preference (SS05971); absent on a view form */
    activityId: String,
    formData: Object,
    item: Object,
    format: String,
    onExecute: Function,
    view: Boolean,
    shareForm: Boolean,
    comfortDesign: Boolean,
    formSettings: Object,
    overflowAuto: Boolean,
    filePreviewDisabled: Boolean,
    inTable: Boolean
  },
  components: {
    "fts-badge": FTSBadge,
    "fts-client-modal": FTSClientModal,
    "fts-display-profile-card": FTSDisplayProfileCard,
    "fts-file": FTSFile,
    "fts-list": FTSList,
    "fts-profile": FTSProfile,
    "fts-table-edit-display": FTSTableEditDisplay,
    "fts-tippy": FTSTippy
  },
  methods: {
    /* Column freeze (SS05971 D33). Sits between the chip (FTSFormElement's label row) and the state
       (FTSTableEditDisplay), so it forwards explicitly — letting FTSFormElement reach through a
       `$refs.display.$refs.table…` chain would break silently on any template move. */
    revealFrozenColumn(index) {
      const table = this.$refs.tableEditDisplay;
      if (table) table.revealFrozenColumn(index);
    },
    toggleFreeze(index) {
      const table = this.$refs.tableEditDisplay;
      if (table) table.toggleFreeze(index);
    },
    unfreezeAllColumns() {
      const table = this.$refs.tableEditDisplay;
      if (table) table.unfreezeAllColumns();
    },
    clickLink() {
      this.onExecute(this.item, this.formData);
    },
    /**
     * @param {Object} item for multiple only
     */
    openQuickView(item) {
      if (this.view && this.$listingMode !== 'detail') {
        const entryId = this.getEntryId(item);
        if (entryId) {
          window.eventBus.$emit("quickViewData", {
            id: entryId,
            vectorId: this.connectionId
          });
          // global open form
          window.eventBus.$emit("app:form:open", {
            entryId: entryId,
            moduleId: this.connectionId
          });
        }
      } else {
        const URL = this.getEntryURL(item);
        if (URL)
          window.open(URL, "_blank");
      }
    },
    toggleQueryUrl() {
      try {
        const urlParams = new URLSearchParams(this.model.url);
        const params = Object.fromEntries(urlParams);
        if (params.d && params.id && params.v) {
          // Asks /doc/manifest first, so an htmljs document opens in its own viewer.
          openDocumentLink(params);
        }
      } catch(err) {
        console.warn("Display:ToggleQueryUrl", err);
      }
    },
    /**
      * @param {String} text
      */
    getColor(text) {
      return commons.selectOptionBackground({
        optionList: this.item.optionList,
        text: text,
      });
    },
    /**
     * @param {Object} item for multiple only
     */
    getEntryId(item) {
      return (this.item.type === 8 || this.item.type === 21)
        ? item.id
        : commons.model(this.formData, this.item.fieldName, true);
    },
    /**
     * @param {Object} item for multiple only
     */
    getEntryURL(item) {
      const entryId = this.getEntryId(item);
      return entryId && `/#/dashboard?id=${commons.queryEncodeids(this.connectionId, entryId)}`;
    },
    openSignatureModal() {
      this.$refs["signature-modal"] && this.$refs["signature-modal"].show();
    }
  },
  computed: {
    model() {
      const result = commons.model(this.formData, this.item.fieldName);
      // yes no
      if (this.item.type === 1 && (result || result === false)) {
        return result ? "Yes" : "No";
      }
      // integer
      else if (this.item.type === 2 && (result || result == 0)) {
        return result ? result : "0";
      }
      // number
      else if (this.item.type === 3 && (result || result === 0)) {
        if (this.item.customFormat) {
          return numeral(result).format(this.item.customFormat);
        } else if (this.item.displayFormat) {
          return numeral(result).format(this.item.displayFormat);
        } else {
          const decimalPlaces = commons.isInteger(this.item.decimalPlaces) ? this.item.decimalPlaces : 2;
          return result.toLocaleString(undefined, {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces,
          });
        }          
      } 
      // currency
      else if (this.item.type === 4 && (result || result == 0)) {
        return numeral(result).format("0,0.00");
      }
      else if (result) {
        // date, date time
        if (this.item.type === 5 || this.item.type === 6) {
          const dateFormat = (format) => luxon.fromISO(result).toFormat(commons.dateFormatTranslate(format));
          if (this.item.enableCustomDateFormat && this.item.customDateFormatId) {
            return dateFormat(this.item.customDateFormatId);
          } else if (this.item.predefinedFormatId) {
            return dateFormat(this.item.predefinedFormatId);
          } else if (this.item.type === 5) {
            return dateFormat('DD');
          } else {
            return dateFormat('DD t');
          }
        }
        // phone number
        else if (this.item.type === 26) {
          if (typeof result === "number") {
            return String(result);
          } else if (typeof result !== "string" || !result.trim()) {
            return null;
          } else {
            return result;
          }
        }
        // display
        else if (
          this.item.input == "display" &&
          Object.prototype.toString.call(result) === "[object Date]"
        ) {
          if (this.item.displayFormat)
            return moment(result).format(this.item.displayFormat);
          else return moment(result).format("ll");
        }
        // location
        else if (this.item.type === 9) {
          // for old data
          return {
            lat: result.lat ? result.lat : result.latitude,
            lng: result.lng ? result.lng : result.longitude,
            placeName: result.placeName,
          };
        }
        // link
        else if (this.item.type === 33) {
          if (result.constructor === String) {
            return {
              url: result,
              name: result,
            };
          } else if (result.constructor === Object) {
            if (result.name != null && result.name != undefined) {
              return result;
            } else if (result.url != null && result.url != undefined) {
              return {
                ...result,
                name: result.url
              };
            }
          }

          return null;
        }
      }
      // table
      else if (this.item.type === 14) {
        return [];
      }

      return result;
    },
    userNameModel() {
      return commons.model(this.formData, `${this.item.fieldName}Username`);
    },
    connectionId() {
      if (this.item.wildcard !== true)
        return this.item.connectionId;
    },
    fileType() {
      if (this.item.type === 10 || this.item.type === 11)
        return "image";
      else if (this.item.type === 12 || this.item.type === 13)
        return "file";
    },
    /* WhatsApp link */
    waLink() {
      return this.model && `https://wa.me/${this.model.replace(/\D+/g, '')}`;
    },
    /* link */
    isQueryUrl() {
      return Boolean(
        this.model &&
        this.model.url &&
        this.model.url.startsWith("?")
      );
    },
    linkURL() {
      if (this.model && this.model.url)
        return this.model.url.toLowerCase().startsWith("http") ? this.model.url : `//${this.model.url}`
    },
    uNCFilePath() {
      if (this.model && this.model.url && uNCValidator(this.model.url)) {
        if (/^([a-zA-Z]\:\\|\\\\)/g.test(this.model.url))
          return `ist://${encodeURIComponent(this.model.url)}`;
        else
          return `file:///${this.model.url}`;
      }
    },
    isConnectionLink() {
      const connectionId = this.item && this.item.connectionId;
      return clientStore.getters.availableModules.some(x => x == connectionId);
    }
  },
  mounted() {
    if (this.item.fieldName && this.item.fieldName.indexOf(".") < 0) {
      if (this.formData[this.item.fieldName] === undefined) {
        Vue.set(this.formData, this.item.fieldName, null);
      }

      if (this.item.input == "dropDown" || this.item.input == "autoComplete") {
        if (this.formData[this.item.fieldName + "Id"] === undefined) {
          Vue.set(this.formData, this.item.fieldName + "Id", 0);
        }

        if (this.formData[this.item.fieldName + "Model"] === undefined) {
          Vue.set(this.formData, this.item.fieldName + "Model", null);
        }
      }
    } else if (this.item.fieldName) {
      var primer = this.formData;
      _.each(this.item.fieldName.split("."), function (field) {
        if (primer !== null) {
          if (primer[field] === undefined) {
            Vue.set(primer, field, null);
            primer[field] = null;
          } else {
            primer = primer[field];
          }
        }
      });
    }
  },
};
</script>

<style lang="scss">
@use "./src/assets/scss/vars" as *;

@mixin border-transparent-x {
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
}

/* to-do v2 */
.fts-display {
  min-height: calc(var(--inistate-paragraph-text-14--line-height) + 0.375rem + 0.375rem + 2px);
  font-family: $font-family;
  font-size: var(--inistate-label-text-14);
  line-height: var(--inistate-paragraph-text-14--line-height);
  word-break: break-word;
  color: var(--fts-text);
  .fts-display-form-control {
    display: flex;
    align-items: center;
    white-space: normal;
    &.normal-display {
      @include border-transparent-x;
    }
    &.yes-no-display {
      .success-theme {
        color: var(--fts-success);
      }
      .danger-theme {
        color: var(--fts-danger);
      }
    }
    &.dropdown-display {
      @include border-transparent-x;
      a {
        @extend .display-link-decoration-none;
      }
    }
    &.dropdown-user-display {
      align-items: flex-start;
      .dropdown-user-display-name {
        min-height: 20px;
        display: flex;
        align-items: center;
        a {
          @extend .display-link-decoration-none;
        }
      }
    }
    &.multi-text-display {
      @include border-transparent-x;
      span {
        white-space: pre-wrap;
      }
    }
    &.location-display {
      align-items: start;
      svg {
        color: var(--fts-primary);
      }
      a {
        @extend .display-link-decoration-none;
        display: inline-flex;
        vertical-align: middle;
      }
      .location-name {
        margin-left: 0.5rem;
      }
    }
    &.contact-link-display {
      @include border-transparent-x;
      .contact-link-display-shortcut {
        margin-left: 0.375rem;
        visibility: hidden;
      }
      a {
        display: flex;
        color: var(--fts-default);
        svg {
          font-size: 1rem;
        }
        &:hover {
          color: var(--fts-primary);
        }
      }
      &:hover .contact-link-display-shortcut {
        visibility: visible;
      }
    }
  }
  .display-link-decoration-none {
    color: var(--fts-primary);
    text-decoration: none;
  }
  .display-icon {
    color: var(--fts-default);
  }
  .signature-display {
    .signature-display-content {
      border: 1px solid var(--fts-form-control-border);
    }
  }
  .context-display {
    flex-direction: column;
    align-items: flex-start;
    .context-display-item {
      &:not(:last-child) {
        margin-bottom: 0.375rem;
      }
    }
  }
  .display-entry-link {
    text-decoration: none;
    color: var(--fts-primary);
  }
  .display-dropdown {
    padding: 0.375rem 0.75rem;
    border: 1px solid transparent;

    .display-dropdown-tag-container {
      @include flex-gap($gap: 0.375rem);
    }

    .display-dropdown-tag {
      padding-left: 0.25rem;
      padding-right: 0.25rem;
      border-radius: 0.25rem;
      background-color: var(--fts-gray-100);
      color: var(--fts-dark);
    }
  }
  .display-user {
    padding: 0.375rem 0.75rem;
    border: 1px solid transparent;
    &.display-user--multiple {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      padding-top: 0;
      .display-user-tag {
        min-width: 0;
        margin-top: 0.375rem;
        margin-right: 0.375rem;
        padding-left: 0.25rem;
        padding-right: 0.25rem;
        border-radius: 0.25rem;
        background-color: var(--fts-gray-100);
      }
    }
  }
  svg {
    font-size: var(--inistate-label-text-14);
  }
  &.comfort-design {
    min-height: $comfort-form-control-height;
    .fts-display-form-control {
      min-height: $comfort-form-control-height;
      padding-left: 0;
      padding-right: 0;
      font-size: $comfort-font-size;
      line-height: $comfort-line-height;
    }
    .fts-table-edit-display .fts-display-form-control {
      padding-left: 0.75rem;
      padding-right: 0.75rem;
      font-size: var(--inistate-label-text-14);
      line-height: var(--inistate-paragraph-text-14--line-height);
    }
  }
}
.display-signature-modal {
  .display-signature-modal-container {
    display: flex;
    justify-content: center;
    > * {
      border: 1px solid var(--fts-border);
    }
  }
}
</style>